import { Button, VStack } from "@chakra-ui/react"
import {
  FaSearchengin,
  FaBookOpen,
  FaListUl,
  FaLightbulb,
  FaPenNib,
} from "react-icons/fa6"

export function FloatingMenuContent({
  onAction,
}: {
  onAction: (
    action:
      | "webSearch"
      | "docSearch"
      | "outline"
      | "idea"
      | "intro"
  ) => void
}) {
  return (
    <VStack align="stretch" gap={0}>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="blue"
        onClick={() => onAction("webSearch")}
      >
        <FaSearchengin style={{ marginRight: "6px" }} />
        웹에서 자료 조사
      </Button>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="blue"
        onClick={() => onAction("docSearch")}
      >
        <FaBookOpen style={{ marginRight: "6px" }} />
        참고자료에서 찾기
      </Button>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="blue"
        onClick={() => onAction("outline")}
      >
        <FaListUl style={{ marginRight: "6px" }} />
        아웃라인 생성
      </Button>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="blue"
        onClick={() => onAction("idea")}
      >
        <FaLightbulb style={{ marginRight: "6px" }} />
        글 아이디어 추천
      </Button>
      <Button
        size="sm"
        variant="ghost"
        colorScheme="blue"
        onClick={() => onAction("intro")}
      >
        <FaPenNib style={{ marginRight: "6px" }} />
        도입부 생성
      </Button>
    </VStack>
  )
}
